// extracted by mini-css-extract-plugin
module.exports = {"line":"GuruttoAi_line__3ZcVU","mobileAppWrapper":"GuruttoAi_mobileAppWrapper__1liNU"};